function slideToContactForm () {
	const clickEls = document.querySelectorAll("[href='#contact']");
	const contactFormEl = document.getElementById("frm-contact-emailForm");

	for (let clickEl of clickEls) {
		clickEl.addEventListener("click", el => {
			contactFormEl.scrollIntoView();
		});
	}
}

export {slideToContactForm};
